var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"bo-main-wrapper"}},[_c('div',{attrs:{"id":"main-container"}},[_c('default-header'),_c('el-row',{attrs:{"id":"app-main","type":"flex","justify":"stretch"}},[_c('default-sidebar'),_c('div',{attrs:{"id":"app-main-content"}},[_c('breadcrumb'),_vm._t("default")],2),_c('default-footer')],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }